export const DEFAULT_FILES_DELIVERY = '15';